import _ from 'lodash';
import {ENDPOINT_VENDOR} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const getSamgovInfoForDuns = (token, duns) => {
  return fetch(`${ENDPOINT_VENDOR}samgovCheck?duns=${duns}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  getSamgovInfoForDuns,
};
